import { useState } from "react";
import { X } from "lucide-react";
import { useRuleFirings } from "@/hooks/useRuleFirings";
import { FiringTimeline } from "./firings/FiringTimeline";
import { FiringDetail } from "./firings/FiringDetail";

const TRIGGER_LABELS = {
  new_critical: "Nuevo crítico",
  new_high: "Nuevo alto",
  kev_match: "Coincidencia KEV",
  rating_drop: "Caída de calificación",
  cert_expiring_7d: "Certificado por vencer",
  new_asset: "Nuevo activo",
};

export function RuleFiringsModal({ rule, onClose }) {
  const [selected, setSelected] = useState(null);
  const items = useRuleFirings(rule);

  if (!rule) return null;

  return (
    <div className="fixed inset-0 z-50 bg-background/85 backdrop-blur-sm flex items-center justify-center p-4" onClick={onClose}>
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-full max-w-4xl bg-card border border-border max-h-[90vh] flex flex-col"
        data-testid="firings-modal"
      >
        <div className="p-5 border-b border-border flex items-start justify-between">
          <div>
            <div className="overline mb-2">Analista IA · Cronología de disparos</div>
            <h2 className="font-display text-2xl font-medium mt-1">{rule.name}</h2>
            <div className="font-mono text-[10px] tracking-widest uppercase text-muted-foreground mt-1">
              {TRIGGER_LABELS[rule.trigger] || rule.trigger}
              {rule.client_name && <> · {rule.client_name}</>}
            </div>
          </div>
          <button onClick={onClose} className="p-1 hover:bg-muted" data-testid="close-firings">
            <X className="w-4 h-4" />
          </button>
        </div>

        <div className="flex-1 overflow-hidden grid grid-cols-1 md:grid-cols-2 min-h-0">
          <div className="border-r border-border overflow-y-auto p-3 space-y-0">
            <FiringTimeline items={items} selectedId={selected?.id} onSelect={setSelected} />
          </div>
          <div className="overflow-y-auto p-5">
            <FiringDetail firing={selected} />
          </div>
        </div>
      </div>
    </div>
  );
}
